'use strict';

import {
  classes,
  addClassToElement,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';
import { updateItemQuantity, removeItemFromCart } from '@jspartials/cart-utils';
import { gtmGetListName } from '@jspartials/gtm-utils';
import { customEvent } from '@jspartials/general-utils';

const STATE_DISABLED_CLASSNAME = 'is-disabled';

const selector = {
  cart: {
    wrapper: '.js-cart',
    summary: '.js-cart__summary',
    checkoutButton: '.js-cart__checkout-button',
    lineItem: {
      wrapper: '.js-cart__list-item',
      action: '.js-cart__list-item-action',
      quantity: '.js-cart__list-item-quantity',
      prices: '.js-cart__list-item-prices',
      button: {
        plus: '.js-cart__list-item-button-plus',
        minus: '.js-cart__list-item-button-minus',
        remove: '.js-cart__list-item-remove'
      }
    },
    donation: '.js-cart__donation-checkbox'
  }
};

function initQuantityButtons(wrapper) {
  if (wrapper) {
    const cartQuantityAddButtons = wrapper.querySelectorAll(
      selector.cart.lineItem.button.plus
    );

    const cartQuantityMinusButtons = wrapper.querySelectorAll(
      selector.cart.lineItem.button.minus
    );

    const cartQuantityInputs = wrapper.querySelectorAll(
      selector.cart.lineItem.quantity
    );

    if (cartQuantityAddButtons) {
      cartQuantityAddButtons.forEach((cartQuantityAddButton) => {
        if (
          !hasClassElement(cartQuantityAddButton, 'js-cart__donation-checkbox')
        ) {
          cartQuantityAddButton.addEventListener('click', function (e) {
            if (
              !hasClassElement(cartQuantityAddButton, STATE_DISABLED_CLASSNAME)
            ) {
              var quantitySelector =
                cartQuantityAddButton.parentElement.querySelector(
                  selector.cart.lineItem.quantity
                );
              var quantity = Number(quantitySelector.value) + 1;
              changeQuantity(
                quantity,
                quantitySelector.dataset.pid,
                quantitySelector.dataset.uuid,
                cartQuantityAddButton,
                wrapper
              );
            }
          });
        }
      });
    }

    if (cartQuantityMinusButtons) {
      cartQuantityMinusButtons.forEach((cartQuantityMinusButton) => {
        cartQuantityMinusButton.addEventListener('click', function () {
          if (
            !hasClassElement(cartQuantityMinusButton, STATE_DISABLED_CLASSNAME)
          ) {
            var quantitySelector =
              cartQuantityMinusButton.parentElement.querySelector(
                selector.cart.lineItem.quantity
              );
            var quantity = Number(quantitySelector.value) - 1;
            changeQuantity(
              quantity,
              quantitySelector.dataset.pid,
              quantitySelector.dataset.uuid,
              cartQuantityMinusButton,
              wrapper
            );
          }
        });
      });
    }
    if (cartQuantityInputs) {
      cartQuantityInputs.forEach((cartQuantityInput) => {
        cartQuantityInput.addEventListener('input', function (e) {
          var quantity = e.target.value;
          const isNumeric =
            (typeof quantity == 'number' ||
              (typeof quantity == 'string' && quantity.trim() !== '')) &&
            !isNaN(quantity);

          // quantity !== '' &&
          //   ((!isNumeric || quantity < 0) &&
          //     (quantity = parseInt(quantity) || 1),
          //   (this.value = Math.max(
          //     this.min || 1,
          //     Math.min(quantity, this.max || Number.MAX_VALUE)
          //   ).toString()));

          if (quantity !== '') {
            if (!isNumeric || quantity < 0) {
              quantity = parseInt(quantity) || 1; // Parse string to get Integer without any character (5`+ -> 5)
            }
            // Limit value between max and mix
            this.value = Math.max(
              this.min || 1,
              Math.min(quantity, this.max || Number.MAX_VALUE)
            ).toString();
          }
        });

        cartQuantityInput.addEventListener('change', function (e) {
          var quantity = Number(cartQuantityInput.value);
          changeQuantity(
            quantity,
            cartQuantityInput.dataset.pid,
            cartQuantityInput.dataset.uuid,
            cartQuantityInput,
            wrapper
          );
        });
      });
    }
  }
}

function initRemoveProductLineButtons(wrapper) {
  if (wrapper) {
    const removeProductLineItemButtons = wrapper.querySelectorAll(
      selector.cart.lineItem.button.remove
    );

    if (removeProductLineItemButtons) {
      removeProductLineItemButtons.forEach((removeProductLineItemButton) => {
        removeProductLineItemButton.addEventListener('click', function () {
          const itemPID = removeProductLineItemButton.dataset.pid;
          const itemUUID = removeProductLineItemButton.dataset.uuid;

          removeProductLineItem(
            itemPID,
            itemUUID,
            removeProductLineItemButton,
            wrapper
          );
        });
      });
    }
  }
}

function findProductLineItem(itemPID, itemUUID, target) {
  var foundItem;
  const closestItem = target.closest('.js-cart__list-item');

  if (
    closestItem &&
    closestItem.dataset.uuid === itemUUID &&
    closestItem.dataset.pid === itemPID
  ) {
    foundItem = closestItem;
  }

  return foundItem;
}

function changeQuantity(newQuantity, itemPID, itemUUID, target, wrapper) {
  const foundItem = findProductLineItem(itemPID, itemUUID, target);
  const foundItemQuantitySelector = foundItem.querySelector(
    selector.cart.lineItem.quantity
  );
  const productLineItemPrices = foundItem.querySelector(
    selector.cart.lineItem.prices
  );
  const oldValue = parseInt(foundItemQuantitySelector.dataset.oldValue);
  var cart = document.querySelector(selector.cart.wrapper);
  const isCartFull = cart && cart?.dataset?.full === 'true';
  const gtmListName = gtmGetListName(target);

  setLoading(productLineItemPrices);
  disableItemActions(foundItem);
  disableSummaryActions(wrapper);

  if (newQuantity <= 0) {
    removeProductLineItem(itemPID, itemUUID, target, wrapper);
  } else {
    updateItemQuantity(
      isCartFull,
      newQuantity,
      oldValue,
      itemPID,
      itemUUID,
      gtmListName
    )
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent('refreshCart', {
            detail: {
              data: data
            }
          })
        );

        if (cart) {
          cart.dataset.full = data.basketModel.isCartFull;
        }
      })
      .catch((error) => {
        document.dispatchEvent(
          new CustomEvent('cartError', {
            detail: {
              error: error
            }
          })
        );
        console.error(error);
        foundItemQuantitySelector.value = oldValue;
        unsetLoading(productLineItemPrices);
      })
      .then(() => {
        enableAllActions();
        enableSummaryActions(wrapper);
      });
  }
}

function removeProductLineItem(itemPID, itemUUID, target, wrapper) {
  var foundItem = findProductLineItem(itemPID, itemUUID, target);
  disableItemActions(foundItem);
  disableSummaryActions(wrapper);
  var cart = document.querySelector(selector.cart.wrapper);
  const gtmListName = gtmGetListName(target);

  removeItemFromCart(itemPID, itemUUID, gtmListName)
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('refreshCart', {
          detail: {
            data: data
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent(customEvent.cart.itemRemoved, {
          detail: {
            itemId: itemPID
          }
        })
      );

      if (cart) {
        cart.dataset.full = data.basketModel.isCartFull;
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .then(() => {
      enableAllActions();
      enableSummaryActions(wrapper);
    });
}

function disableItemActions(wrapper) {
  if (wrapper) {
    const itemActions = wrapper.querySelectorAll(selector.cart.lineItem.action);
    itemActions.forEach((action) => {
      action.disabled = true;
    });
  }
}

function disableSummaryActions(wrapper) {
  var checkoutButton = wrapper.querySelector(selector.cart.checkoutButton);
  var cartSummary = wrapper.querySelector(selector.cart.summary);
  addClassToElement(cartSummary, classes.is.loading);
  if (checkoutButton) {
    checkoutButton.disabled = true;
  }
}

function enableSummaryActions(wrapper) {
  var checkoutButton = wrapper.querySelector(selector.cart.checkoutButton);
  var cartSummary = wrapper.querySelector(selector.cart.summary);

  removeClassToElement(cartSummary, classes.is.loading);
  if (checkoutButton) {
    checkoutButton.disabled = false;
  }
}

function enableAllActions() {
  const itemActions = document.querySelectorAll(selector.cart.lineItem.action);
  itemActions.forEach((action) => {
    action.disabled = false;
  });
}

function setLoading(node) {
  addClassToElement(node, classes.is.loading);
}

function unsetLoading(node) {
  removeClassToElement(node, classes.is.loading);
}

export {
  initQuantityButtons,
  initRemoveProductLineButtons,
  disableSummaryActions,
  enableSummaryActions,
  removeProductLineItem,
  disableItemActions
};
